export default "__VITE_ASSET__SX_N4KgJ__"